"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = exports.getHistoryState = exports.configRouters = exports.getRouterRegs = exports.getRouterByPath = exports.getRouterByKey = exports.getRouters = void 0;
var React = __importStar(require("react"));
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var serverData_1 = require("../utils/serverData");
var ServerDataContext_1 = __importDefault(require("../utils/ServerDataContext"));
var routers = [];
var routersMap = {};
function getRouters() {
    return routers;
}
exports.getRouters = getRouters;
function getRouterByKey(key) {
    return routersMap[key];
}
exports.getRouterByKey = getRouterByKey;
function getRouterByPath(pathname) {
    var resRouter = null;
    routers.some(function (router) {
        if (react_router_1.matchPath(pathname, { path: router.path })) {
            resRouter = router;
            return true;
        }
        return false;
    });
    return resRouter;
}
exports.getRouterByPath = getRouterByPath;
exports.getRouterRegs = function () {
    var pathRegs = [];
    routers.forEach(function (item) {
        pathRegs = pathRegs.concat(item.path);
    });
    return pathRegs;
};
function configRouters(routersConfig) {
    routers = routersConfig;
    routersConfig.forEach(function (item) {
        routersMap[item.key] = item;
    });
}
exports.configRouters = configRouters;
function RouteComponent(route) {
    var serverData = React.useContext(ServerDataContext_1.default);
    return function (props) {
        return React.createElement(route.component, __assign({}, props, { serverData: serverData, routes: route.routes }));
    };
}
function RouteWithSubRoutes(_a) {
    var onRouterChange = _a.onRouterChange, routerUpdate = _a.routerUpdate, routerLeave = _a.routerLeave, lastRoute = _a.lastRoute, route = __rest(_a, ["onRouterChange", "routerUpdate", "routerLeave", "lastRoute"]);
    React.useEffect(function () {
        typeof routerUpdate === 'function' && routerUpdate(route, lastRoute);
        onRouterChange(route);
        return function () {
            typeof routerLeave === 'function' && routerLeave(route);
        };
    }, []);
    return React.createElement(react_router_dom_1.Route, { path: route.path, render: RouteComponent(route) });
}
function Routers(_a) {
    var routerUpdate = _a.routerUpdate, routerLeave = _a.routerLeave;
    var _b = React.useState(null), lastRoute = _b[0], setLastRoute = _b[1];
    var routerChange = React.useCallback(function (route) {
        setLastRoute(route);
    }, []);
    return (React.createElement(react_router_dom_1.Switch, null, routers.map(function (route, idx) { return (React.createElement(RouteWithSubRoutes, __assign({}, route, { key: route.key, lastRoute: lastRoute, onRouterChange: routerChange, routerUpdate: routerUpdate, routerLeave: routerLeave }))); })));
}
exports.default = Routers;
function getHistoryState() {
    var state = null;
    try {
        var history_1 = react_router_dom_1.useHistory();
        state = history_1 ? history_1.location.state : null;
        if (!state || !Object.keys(state).length) {
            state = null;
        }
    }
    catch (err) {
        console.log('err: ', err);
    }
    return state;
}
exports.getHistoryState = getHistoryState;
function Link(props) {
    var children = props.children, to = props.to;
    if (serverData_1.spa()) {
        return React.createElement(react_router_dom_1.Link, __assign({}, props), children);
    }
    var href = to.toString();
    return React.createElement("a", { href: href }, children);
}
exports.Link = Link;
//# sourceMappingURL=routers.js.map